<div class="ui-g page-header-c pop-p">
  <div class="ui-g-12 ui-md-6 ui-lg-6">
    <h2 class="page-header-c popup-header">Open Shift</h2>
  </div>
  <div class="ui-g-12 ui-md-6 ui-lg-6 shift-popup-header">
    <span class="backbtn " (click)="cancelUserForm()"><i class="fa fa-times fa-2x"></i></span>
  </div>
</div>
<div class="panel-div booking-details-header open-shifts-pop">

  <div class="ui-g pb-20 mr-open-shift" >

    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
      <div class="ui-g-2 ui-sm-2">
        <div class="trip-details-lable" translate>Team</div>
      </div>
      <div class="ui-g-3 ui-sm-3 mr-10">
        <div class="trip-details-value">
          {{openShiftTeamDetails?.teamName ? openShiftTeamDetails?.teamName : 'NA'}}
        </div>
      </div>
      <div class="ui-g-2 ui-sm-2">
        <div class="trip-details-lable" translate>Shift Date</div>
      </div>
      <div class="ui-g-3 ui-sm-3">
        <div class="trip-details-value">
          {{openShiftTeamDetails?.dateStr | date: 'MMM dd, YYYY'}}
        </div>
      </div>
      <div class="ui-g-4 ui-sm-4">
        <div class="trip-details-lable" translate>Broadcasted On</div>
      </div>
      <div class="ui-g-3 ui-sm-3">
        <div class="trip-details-value">
          {{ getBroadcastedCreatedBy(openShiftTeamDetails) }}
        </div>
      </div>
    </div>

    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
      <div class="ui-g-2 ui-sm-2">
        <div class="trip-details-lable" translate>Applications</div>
      </div>
      <div class="ui-g-3 ui-sm-3 mr-10">
        <div class="trip-details-value">
          {{openShiftTeamDetails?.applicationCount}} Requests
        </div>
      </div>
      <div class="ui-g-2 ui-sm-2">
        <div class="trip-details-lable" translate>Shift Time</div>
      </div>
      <div class="ui-g-3 ui-sm-3">
        <div class="trip-details-value">
          {{openShiftTeamDetails?.startDateTimeStr}} - {{openShiftTeamDetails?.endDateTimeStr}}
        </div>
      </div>
      <div class="ui-g-4 ui-sm-4">
        <div class="trip-details-lable" translate>Broadcasted By</div>
      </div>
      <div class="ui-g-3 ui-sm-3">
        <div class="trip-details-value">
          {{openShiftTeamDetails?.createdByFirstName}} {{openShiftTeamDetails?.createdByLastName}}
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
      <div class="ui-g-4 ui-sm-4">
        <div class="trip-details-lable" translate>Team Members</div>
      </div>
      <div class="ui-g-9 ui-sm-9 shift-ava" *ngIf="openShiftTeamDetails?.shiftMembers.length === 0">
        <div class="trip-details-value">
          Not available
        </div>
      </div>
      <div class="member-slot">
        <div class="ui-g-9 ui-sm-9" style="display: inline-flex;" *ngFor="let shiftMembers of openShiftTeamDetails?.shiftMembers">
          <div class="trip-details-value" *ngIf="shiftMembers.firstName !== ''">
            {{shiftMembers?.firstName}} {{shiftMembers?.lastName}} - 
            <span class="pr-schedules" *ngFor="let userSchedules of shiftMembers.userSchedules; last as isLast">{{userSchedules?.slotTimeStr}}<span *ngIf="!isLast">, </span> 
          </span>
          <span class="pr-schedules" *ngIf="shiftMembers.userSchedules.length === 0">Not Available</span>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g-12 ui-md-12 ui-lg-12 ui-g-nopad">
      <div class="ui-g-2 ui-sm-2">
        <div class="trip-details-lable" translate>Notes</div>
      </div>
      <div class="ui-g-6 ui-sm-6">
        <div class="trip-details-value" *ngIf="openShiftTeamDetails?.notes !== ''">
          {{openShiftTeamDetails?.notes}}
        </div>
        <div class="trip-details-value" *ngIf="openShiftTeamDetails?.notes === ''">
          --
        </div>
      </div>
    </div>
  </div>
</div>
<div class="ui-g-12 grid-top open-shift-grid">
  <app-mi-grid-v2 [url]="url" [columnDefs]="columns" (totalCount)="totalCount($event)" [bottomSearchBar]="searchDisplay"
    [actionButtonsDefs]="buttons" (actionBtnClickedEvent)="onActionBtnClicked($event)" actionWidth="150"
    [paginationPageSize]="10" [actionButtonsDefs]="buttons" rowSelection="multiple" [exportUrl]="exportUrl"
    [printUrl]="printUrl" divClass="mi-grid"></app-mi-grid-v2>
</div>
<div class="form-buttons ui-g-12 pt-20 mrg-top" *ngIf="statusId === 810 || statusId === 820">
  <button class="cancel-btn" pButton type="button" [label]="'Retract Broadcast' | translate"
    (click)="retractBroadcastBut()"></button>
</div>